export const SIZES = ['default', 'md'] as const

export type Size = (typeof SIZES)[number]

export interface Props {
  name: string
  size?: Size
}
